import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage | null = null;

  constructor(private storage: Storage) {}

  async init() {
    const storage = await this.storage.create();
    this._storage = storage;
  }

  // Async methods for complex data
  async set(key: string, value: unknown) {
    return this._storage?.set(key, value);
  }

  async get(key: string) {
    return this._storage?.get(key);
  }

  async remove(key: string) {
    return this._storage?.remove(key);
  }

  async clear() {
    return this._storage?.clear();
  }

  async keys() {
    return this._storage?.keys();
  }

  async length() {
    return this._storage?.length();
  }

  // Synchronous methods for critical data that needs to be available immediately
  // These use localStorage as a fallback for scenarios where immediate access is needed
  setSync(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
      // Also set in async storage when available
      if (this._storage) {
        this._storage.set(key, value).catch(error => 
          console.warn('Failed to sync to async storage:', error)
        );
      }
    } catch (error) {
      console.warn('Failed to set sync storage:', error);
    }
  }

  getSync(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.warn('Failed to get sync storage:', error);
      return null;
    }
  }

  removeSync(key: string): void {
    try {
      localStorage.removeItem(key);
      // Also remove from async storage when available
      if (this._storage) {
        this._storage.remove(key).catch(error => 
          console.warn('Failed to sync removal to async storage:', error)
        );
      }
    } catch (error) {
      console.warn('Failed to remove sync storage:', error);
    }
  }
}